/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_IntroInputs */

const en_login_page_intro = /** @type {(inputs: Login_Page_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to access your dashboard and all features.`)
};

const de_login_page_intro = /** @type {(inputs: Login_Page_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich an, um auf Ihr Dashboard und alle Funktionen zuzugreifen.`)
};

/**
* | output |
* | --- |
* | "Sign in to access your dashboard and all features." |
*
* @param {Login_Page_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_page_intro = /** @type {((inputs?: Login_Page_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_page_intro(inputs)
	return en_login_page_intro(inputs)
});